import {useMemo} from 'react'

import {renderWidget} from '../../../../index'
import {AddressWidgetConfig} from '../../../../types'

type UseAddressPointSlotReturn = {
  /**
   * Текстовка для компонента `AddressPoint` с типом адреса и выбранным адресом
   */
  AddressPointDescription: React.ReactNode[]
  /**
   * Lead-компонент Slot
   */
  Lead: React.ReactNode
  /**
   * Trail-компонент Slot
   */
  Trail: React.ReactNode
}

type DescriptionKey = keyof Pick<AddressWidgetConfig, 'selected_description' | 'unselected_description'>

/**
 * Хук, возвращающий набор компонентов, контент которых зависит от того, выбран ли адрес внутри виджета `AddressWidget`
 * @param isAddressSelected Выбран ли адрес
 * @param addressWidgetConfig конфигурация виджета `AddressWidget`
 * @returns
 */
export const useAddressPointSlot = (
  isAddressSelected: boolean,
  addressWidgetConfig: AddressWidgetConfig,
): UseAddressPointSlotReturn => {
  const leadKey = useMemo(() => (isAddressSelected ? 'selected_lead' : 'unselected_lead'), [isAddressSelected])
  const descriptionKey = useMemo<DescriptionKey>(
    () => (isAddressSelected ? 'selected_description' : 'unselected_description'),
    [isAddressSelected],
  )

  const AddressPointDescription = useMemo(
    () => addressWidgetConfig[descriptionKey].items.map(renderWidget),
    [descriptionKey, addressWidgetConfig],
  )
  const SuggestLead = useMemo(
    () => addressWidgetConfig[leadKey] && renderWidget(addressWidgetConfig[leadKey]),
    [leadKey, addressWidgetConfig],
  )
  const SuggestTrail = useMemo(
    () => addressWidgetConfig.trail && renderWidget(addressWidgetConfig.trail),
    [addressWidgetConfig.trail],
  )

  return {AddressPointDescription, Lead: SuggestLead, Trail: SuggestTrail}
}
